export const publicRoutes = [
  'confirm-newsletter-subscription',
  'login',
  'register',
  'confirm-registration',
  'forgot-password',
  'magic-link-proceed',
  'onboarding'
]